<script setup>
import DelimiterSection from "@sections/delimiter-crosses.vue";

import Button from "@components/global/button.vue";
</script>

<template>
	<div class="container">
		<section class="flex h-[calc(100vh-525px)] flex-col items-center justify-center gap-5">
			<DelimiterSection :rows="2" class="-mt-10" />
			<h4 class="text-center uppercase text-paper-light">404 - Not Found</h4>
			<Button class="default" :to="{ name: 'index' }" icon="fa-solid fa-arrow-up-right sm:text-base text-[12px] leading-4">Back to Home</Button>
		</section>
	</div>
</template>
